export default __webpack_public_path__ + "static/media/qw.3522f2e4.jpg";